import { useUnistyles } from "react-native-unistyles";

import CustomPlatform from "$src/core/utils/platform/platform";

// TODO: Improve this when Expo supports this out of the box
const useTabBarHeight = () => {
  const { theme } = useUnistyles();

  return CustomPlatform.select({
    // Android TV draws its own pill, which ends lower than the tvOS bar.
    androidTV: theme.spacing(24),
    tv: theme.spacing(18),
    native: theme.spacing(16),
    web: theme.spacing(28),
    default: 0,
  });
};

export default useTabBarHeight;
